/*
    创建者：shuxiaokai
    创建时间：2019-09-06 11:31
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div class="login-container d-flex a-center j-center">
        <div class="login-box d-flex">
            <div class="left">
                
            </div>
            <div class="right">
                <h2 class="text-center">欢迎登录</h2>
                <el-tabs v-model="activeName" class="w-100" @tab-click="handleClickTabs">
                    <el-tab-pane label="账号登录" name="first">
                        <el-form :model="userInfo" :rules="rules" @submit.native.stop.prevent="onSubmit('loginForm')">
                            <el-form-item prop="username" class="mb-2">
                                <el-input v-model="userInfo.username" prefix-icon="el-icon-user" name="username" type="text" autocomplete="off" placeholder="请输入用户名..."></el-input>
                            </el-form-item>
                            <el-form-item prop="password" class="mb-2">
                                <el-input v-model="userInfo.password" prefix-icon="el-icon-lock" name="password" type="password" autocomplete="off" placeholder="请输入密码..."></el-input>
                            </el-form-item>
                            <el-form-item>
                                <div class="captcha">
                                    <el-input v-model="userInfo.code" name="code" type="text" autocomplete="off" placeholder="验证码"></el-input>
                                    <img :src="captchaUrl" @click="freshCapchaUrl">
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button v-loading="loading" type="primary" native-type="submit" size="small" class="w-100">登录</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="手机登录" name="second">
                        
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //=====================================登录参数====================================//
            rules: {},
            userInfo: {
                username: "shu",
                password: "111111",
                code: ""
            },
            random: Math.random(),
            //=====================================其他参数====================================//
            activeName: "first",
            loading: false
        };
    },
    computed: {
        captchaUrl() {
            const isProcess = this.$root.VUE_BASE_CONFIG.isProcess
            const requestUrl = isProcess ? this.$root.VUE_BASE_CONFIG.devUrl : this.$root.VUE_BASE_CONFIG.proUrl;
            return requestUrl + `/api/security/captcha?width=120&height=40&random=${this.random}`;
        }
    },
    created() {},
    mounted() {

    },
    methods: {
        //=====================================前后端交互====================================//
        login() {
            // this.axios.post("/api/security/login", this.userInfo).then(res => {
            //     localStorage.setItem("token", res.data);
            //     this.$router.push("/v1/a/a");
            // }).catch(err => {
            //     this.$errorThrow(err, this);
            // });
        },        
        //=====================================组件操作====================================//
        handleClickTabs() {

        },
        //刷新验证码
        freshCapchaUrl() {
            this.random = Math.random();
        },

    }
};
</script>



<style lang="scss">
.login-container {
    width: 100vw;
    height: 100vh;
    .login-box {
        height: size(450);
        width: size(750);
        background: $white;
        box-shadow: $box-shadow-sm;
        border-radius: $border-radius-base;
        .left {
            flex: 0 0 40%;
            background: rgba(68, 99, 178, 1);
        }
        .right {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 0 size(40);
            height: 100%;
            &>h2 {
                margin-top: size(50);
            }
            .captcha {
                display: flex;
                &>img {
                    width: size(200);
                    height: size(40);
                }
            }
        }
    }
}
</style>
